import { useMemo } from 'react'

//* HOCs
import { withUIContext } from 'context'

//* Components
import { Text, ButtonFollow, Icon, CustomLink, Avatar } from 'components/common'

//* Style
import FollowersPopupStyle from './style'

const FollowersPopup = ({
    follows,
    popupType,
    toggleDeactivatePopup,
    popupIsOpen,
    popupComponent,
    enableDomScroll,
    toggleContactPopup,
    toggleConProPopup,
    followersPopupIsOpen,
    toggleFollowersPopup,
    ...props
}) => {

    const popupClick = (e) => {
        if (e.target.className.includes('parent-cont')) {
            toggleDeactivatePopup()
            toggleConProPopup()
            toggleFollowersPopup()
        }
        enableDomScroll()
    }

    const storePopupData = useMemo(() => {
        return follows?.map((follow, k) => {
            return (
                <div className='single-user flexBox spaceBetween alignMiddle' key={k}>
                    <CustomLink url={`/${follow.username}`} onClick={toggleFollowersPopup}>
                        <div className='left flexBox'>
                            <Avatar src={follow.avatar} />
                            <div className='info flexBoxColumn'>
                                <Text tag='h5' className='PopSemi h5' text={follow.name} />
                                <Text tag='p' className='PopReg h7 darkGrey' text={`${follow.debatesCount} debates created`} />
                            </div>
                        </div>
                    </CustomLink>
                    <ButtonFollow followingId={follow.id} />
                </div>
            )
        })
    }, [follows])

    return followersPopupIsOpen ? (
        <FollowersPopupStyle onClick={(e) => popupClick(e)} className={`parent-cont flexBoxColumn alignCenter alignMiddle ${props.className}`}>
            <div className='popup-cont'>
                <Icon onClick={() => toggleFollowersPopup()} className='op-close' />
                <Text tag='p' className='PopSemi h9' text={`${follows?.length} ${popupType}`} />
                <div className='follow-cont flexBoxColumn'>{storePopupData}</div>
            </div>
        </FollowersPopupStyle>
    ) : null
}

export default withUIContext(FollowersPopup, [
    'enableDomScroll',
    'toggleDeactivatePopup',
    'popupIsOpen',
    'popupComponent',
    'toggleContactPopup',
    'toggleConProPopup',
    'followersPopupIsOpen',
    'toggleFollowersPopup',
])
